
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('benefitDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <template  v-if="this.$parent.foundBenefits.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteBenefit') }}</label>
                        <div v-for="(benefit, i) in this.$parent.foundBenefits" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + benefit.selectionId + '/package/' + benefit.selectionPackageId ">
                                {{ benefit.name }}
                            </RouterLink>
                        </div>
                    </template>
                    <p v-else>{{ $t('wannaDeleteThisBenefit') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteBenefit" :disabled="this.$parent.foundBenefits.length > 0">
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import BenefitApi from "../../api/server/benefit";

export default {
    name: "benefitDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteBenefit() {
            await BenefitApi.benefitDelete(this.$parent.$route.params.id, this.$parent.benefitToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        },
    }
};
</script>